import { render, staticRenderFns } from "./_base-modal.vue?vue&type=template&id=01eb2870&scoped=true&"
import script from "./_base-modal.vue?vue&type=script&lang=js&"
export * from "./_base-modal.vue?vue&type=script&lang=js&"
import style0 from "./_base-modal.vue?vue&type=style&index=0&id=01eb2870&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eb2870",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VDivider,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01eb2870')) {
      api.createRecord('01eb2870', component.options)
    } else {
      api.reload('01eb2870', component.options)
    }
    module.hot.accept("./_base-modal.vue?vue&type=template&id=01eb2870&scoped=true&", function () {
      api.rerender('01eb2870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-modal.vue"
export default component.exports